import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    carouselContainer: {
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        borderRadius: 10,
        padding: `${theme.spacing(2)} ${theme.spacing(6)} 0 ${theme.spacing(6)}`,
        height: "100%",
        "@media (min-width: 1300px)": {
            paddingTop: `${theme.spacing(3)}`,
        },
    },
}));
